import { useCallback, useState } from 'react';
import NewCoverCard from '@src/pages/lessonlibrary/gradeItem/NewCoverCard/NewCoverCard';
import LessonProgressModal from '@src/components/lesson-progress-modal/LessonProgressModal';
import { AiLessonCard } from './aiSearch';
import styles from './AiLessonGrid.module.scss';

type Props = {
  cards: AiLessonCard[];
  isAUuser: boolean;
  /** Names where the lesson was opened from, for the lesson open analytics. */
  programName: string;
  compact?: boolean;
};

function AiLessonGrid({ cards, isAUuser, programName, compact = false }: Props) {
  const [opened, setOpened] = useState<AiLessonCard | null>(null);

  const handleClose = useCallback(() => setOpened(null), []);

  return (
    <>
      <div className={[styles.grid, compact ? styles.compact : ''].join(' ')}>
        {cards.map((card) => (
          <div key={card.lesson.id} className={styles.card}>
            <NewCoverCard
              content={card.lesson as any}
              country=""
              isAUuser={isAUuser}
              handleOpenContent={() => setOpened(card)}
              cardContext="lessonLibrary"
            />
            {card.grades.length > 0 && (
              <p className={styles.grades}>{card.grades.join(' · ')}</p>
            )}
          </div>
        ))}
      </div>
      {opened ? (
        <LessonProgressModal
          open
          onClose={handleClose}
          lessonId={opened.lesson.id}
          gradeName={opened.mCollectionName}
          mcId={opened.mCollectionId}
          mcName={opened.mCollectionName}
          programName={programName}
        />
      ) : null}
    </>
  );
}

export default AiLessonGrid;
